import React from 'react';
import { BookOpen, ChevronRight } from 'lucide-react';
import { NavLink } from 'react-router-dom';

interface ResourceProps {
  addNotification: (message: string, type: 'success' | 'error' | 'info' | 'warning') => void;
}

const Resource: React.FC<ResourceProps> = ({ addNotification }) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-3">
          <BookOpen className="h-8 w-8 text-indigo-600" />
          <div>
            <h1 className="text-2xl font-bold text-slate-100">Resource Center</h1>
            <p className="text-slate-300 mt-1">Educational resources and documentation for HIVEAIASSURE</p>
          </div>
        </div>
      </div>

      {/* Resource Categories */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Glossary Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-blue-100 rounded-lg">
              <BookOpen className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-slate-100">Glossary</h3>
          </div>
          <p className="text-slate-300 mb-4">
            Comprehensive definitions of RAGAS evaluation metrics used in HIVEAIASSURE for assessing RAG system performance.
          </p>
          <NavLink
            to="/resource/glossary"
            className="inline-flex items-center text-indigo-600 hover:text-indigo-700 font-medium group"
          >
            View Glossary
            <ChevronRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </NavLink>
        </div>

        {/* Documentation Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-green-100 rounded-lg">
              <BookOpen className="h-6 w-6 text-green-600" />
            </div>
            <h3 className="text-lg font-semibold text-slate-100">Documentation</h3>
          </div>
          <p className="text-slate-300 mb-4">
            Technical documentation including the Hybrid Document Processing Approach and implementation guides.
          </p>
          <NavLink
            to="/resource/documentation"
            className="inline-flex items-center text-indigo-600 hover:text-indigo-700 font-medium group"
          >
            View Documentation
            <ChevronRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </NavLink>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 opacity-60">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-gray-100 rounded-lg">
              <BookOpen className="h-6 w-6 text-slate-400" />
            </div>
            <h3 className="text-lg font-semibold text-slate-400">Best Practices</h3>
          </div>
          <p className="text-slate-400 mb-4">
            Coming soon: Best practices and tips for effective RAG system testing and evaluation.
          </p>
          <span className="text-slate-400 font-medium">Coming Soon</span>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-slate-100 mb-4">Available Resources</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="text-center p-4 bg-green-50 rounded-lg">
            <div className="text-2xl font-bold text-green-600">7</div>
            <div className="text-sm text-slate-300">RAGAS Metrics</div>
          </div>
          <div className="text-center p-4 bg-blue-50 rounded-lg">
            <div className="text-2xl font-bold text-blue-600">1</div>
            <div className="text-sm text-slate-300">Evaluation Framework</div>
          </div>
          <div className="text-center p-4 bg-purple-50 rounded-lg">
            <div className="text-2xl font-bold text-purple-600">2</div>
            <div className="text-sm text-slate-300">Resources Available</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resource;
